var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle-switch",class:{ checked: _vm.modelValue },on:{"click":_vm.toggle}})}
var staticRenderFns = []

export { render, staticRenderFns }